import React, { useState } from 'react'
import { Modal, Form, Select ,message} from 'antd'
import $$ from 'cmn-utils';

export default function ({ refs }) {

  const [visible, setVisible] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)

  const [form] = Form.useForm()

  refs.current = {
    open: () => onOpen()
  }

  const onOpen = async () => {
    setVisible(true)
    const res = await $$.get(`/datacenter/api/v1/factorys/${localStorage.getItem('orgId')}`)
    if (!res.success) {
      return
    }
    let introduction = []
    if (res.data.introduction.includes('[')) {
      introduction = JSON.parse(res.data.introduction)
    }
    form.setFieldsValue({
      ...res.data,
      introduction
    })
  }

  const onSubmit = async (values) => {
    setConfirmLoading(true)
    const res = await $$.send('/datacenter/api/v1/factorys', {
      method: 'PUT',
      data: {
        ...values,
        introduction: JSON.stringify(values.introduction)
      }
    })
    setConfirmLoading(false)
    if (res.success) {
      message.success("操作成功！")
      onClose()
    }
  }

  const onClose = () => {
    setVisible(false)
    form.resetFields()
  }

  return (
    <Modal title='告警提示音配置' visible={visible} confirmLoading={confirmLoading} centered
      onOk={() => form.submit()} onCancel={onClose} maskClosable={false}
    >
      <Form form={form} onFinish={onSubmit} layout='vertical'>
        <Form.Item name="address" hidden />
        <Form.Item name="alias" hidden />
        <Form.Item name="areaCode" hidden />
        <Form.Item name="cityCode" hidden />
        <Form.Item name="contacts" hidden />
        <Form.Item name="dataOrigin" hidden />
        <Form.Item name="factoryId" hidden />
        <Form.Item name="genAsset" hidden />
        <Form.Item name="id" hidden />
        <Form.Item name="logo" hidden />
        <Form.Item name="name" hidden />
        <Form.Item name="phone" hidden />
        <Form.Item name="provinceCode" hidden />
        <Form.Item name="sort" hidden />
        <Form.Item name="status" hidden />
        <Form.Item label="声音播放分钟" name="introduction">
          <Select mode="multiple" allowClear filterOption={(input, { label }) => label?.includes(input)}
            options={new Array(60).fill('').map((_, index) => ({ label: `${index}分`, value: index }))}
            placeholder='全部时间'
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}